import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import Arena from '../../../pages/Arena';
import SingleArenaMobile from '../../MobileComponents/Arena/SingleArenaMobile';

const SingleArenaResponsive = () => {
    const { isMobile } = useResponsiveRedux();

    return isMobile ? <SingleArenaMobile /> : <Arena />;
};

export default SingleArenaResponsive;